import React, { useState } from "react";
import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ClearIcon from "@mui/icons-material/Clear";
import { useTranslation } from "react-i18next";

interface SortHeaderProps {
    label: string | React.ReactNode;
    columnName: string;
    colFilter: string;
    direction: string;
    onSort: (columnName: string, direction: string) => void;
    marginTop?: string;
}

const SortHeader: React.FC<SortHeaderProps> = ({ label, columnName, colFilter, direction, onSort,marginTop }) => {
    const [t] = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const applySorting = (sortDirection: string) => {
        onSort(columnName, sortDirection);
        handleMenuClose();
    };

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Box >
                {label}
            </Box>
            <IconButton color="primary" size="small" onClick={handleMenuOpen} sx={{ flex: "0 0 auto", ml: 0, mt:{marginTop}}}>
                {colFilter !== columnName ? (
                    <SwapVertIcon className="swapVertIcon" />
                ) : direction === "ASC" ? (
                    <ArrowUpwardIcon className="sortingIconPosition" />
                ) : (
                    <ArrowDownwardIcon className="sortingIconPosition" />
                )}
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
            >
                <MenuItem onClick={() => applySorting("ASC")}>
                    <ArrowUpwardIcon color="disabled" />{t("business_report.sort_ascending")}
                </MenuItem>
                <MenuItem onClick={() => applySorting("DESC")}>
                    <ArrowDownwardIcon color="disabled" />{t("business_report.sort_descending")}
                </MenuItem>
            </Menu>
        </Box>
    );
};

export default SortHeader;
